module.exports = __webpack_public_path__ + "static/tat-25-7dc0f635b3eb227286a8e9b913d4ed12.jpg";